import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Place";
import {
  mapLayerTypes,
  coordinateFormatTypes,
} from "../userDataTypes";


const PreferencesSection = (props) => (
  <Fragment>
              <h4>{props.translate("sharedPreferences")}</h4>
              <Grid container spacing={2}>
                <Grid item md={3} sm={6} xs={12} title={""}>
                  <TextField
                    id="phone"
                    label={props.translate("sharedPhone")}
                    type="number"
                    placeholder=""
                    value={props.form.phone}
                    onChange={props.handleChange("phone")}
                    error={
                      Boolean(props.phoneError) ||
                      Boolean(props.addUserFieldErrors?.phone)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    helperText={props.phoneError}
                  />
                </Grid>

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="coordinateFormat"
                    select
                    label={props.translate("CoordinateFormat")}
                    value={props.form.coordinateFormat || ""}
                    onChange={props.handleChange("coordinateFormat")}
                    SelectProps={{
                      MenuProps: {
                        className: props.classes.menu,
                      },
                    }}
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>{props.translate("none")}</em>
                    </MenuItem>
                    {coordinateFormatTypes.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {props.translate(option.name)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="map"
                    select
                    label={props.translate("mapTitle")}
                    value={props.form.map || ""}
                    onChange={props.handleChange("map")}
                    SelectProps={{
                      MenuProps: {
                        className: props.classes.menu,
                      },
                    }}
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>{props.translate("none")}</em>
                    </MenuItem>
                    {mapLayerTypes.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {props.translate(option.name)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="latitude"
                    type="number"
                    label={props.translate("positionLatitude")}
                    placeholder=""
                    value={props.form.latitude || ""}
                    onChange={props.handleChange("latitude")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="longitude"
                    type="number"
                    label={props.translate("positionLongitude")}
                    value={props.form.longitude || ""}
                    onChange={props.handleChange("longitude")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="zoom"
                    label={props.translate("serverZoom")}
                    type="number"
                    placeholder=""
                    value={props.form.zoom}
                    error={
                      props.form.zoom > 19 ||
                      props.form.zoom < 3 ||
                      Boolean(props.addUserFieldErrors?.zoom)
                    }
                    helperText={props.translate("enterValue3to18")}
                    onChange={props.handleChange("zoom")}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Tooltip title="Add Location">
                    <IconButton onClick={props.handleClickShowPostion}>
                      {<EditIcon />}
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
  </Fragment>
);

export default PreferencesSection;
